import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
interface Author {
  name: string
  publicUserId: number
  userImage: {
    variants: {
      ['400px']: { src: string }
    }
  }
}
// helper functions
const replaceAmpersand = (text: string): string => text?.replace(/&amp;/g, '&')
const getArticleId = (): number | undefined => {
  const url = new URL(window.location.href)
  const pathname = url.pathname
  const id = pathname.split('-').pop()
  return id ? +id : undefined
}

const TitleLead = ({
  tenant,
  colorMode,
}: {
  tenant: Tenant
  colorMode: 'light' | 'dark'
}) => {
  const [foundAuthors, setFoundAuthors] = useState<Author[]>([
    {
      name: 'Christian Brönnimann',
      publicUserId: 56167670,
      userImage: {
        variants: {
          '400px': {
            src: 'https://cdn.unitycms.io/images/AobcX-YWa1_8s2Z3ucsqCA.jpg?op=ocroped&val=400,400,500,1000,0,250&sum=x3V-v5kNJV8',
          },
        },
      },
    },
    {
      name: 'Cyrill Pinto',
      publicUserId: 16261937,
      userImage: {
        variants: {
          '400px': {
            src: 'https://cdn.unitycms.io/images/DOH1O-yhK0RAeCpH_eDNFA.jpg?op=ocroped&val=400,400,501,1000,0,250&sum=_9qRNrOrkxE',
          },
        },
      },
    },
    {
      name: 'Svenson Cornehls',
      publicUserId: 38525508,
      userImage: {
        variants: {
          '400px': {
            src: 'https://cdn.unitycms.io/images/7dh4JwEDaNBAXKu7jF2aGT.jpg?op=ocroped&val=400,400,500,1000,0,250&sum=U6MWqTHB3B4',
          },
        },
      },
    },
    {
      name: 'Dariush Mehdiaraghi',
      publicUserId: 68585244,
      userImage: {
        variants: {
          '400px': {
            src: 'https://cdn.unitycms.io/images/BVvIgMU-4CpAk-oF2vEtGF.png?op=ocroped&val=400,400,1000,1000,0,0&sum=OYOmYTuxf5w',
          },
        },
      },
    },
  ])
  const [foundTitle, setFoundTitle] = useState<string>(
    tenant.lang === 'fr' ? 'Les super-riches suisses alimentent le boom des jets privés':'Diese superreichen Schweizer befeuern den Privatjet-Boom – auf Kosten des Klimas'
  )
  const [foundLead, setFoundLead] = useState<string | JSX.Element>(
    tenant.lang === 'fr' ? <>Le ciel helvétique est rempli de jets privés. Certains émettent autant de CO<sub>2</sub> en seulement trois heures de vol qu'un Suisse moyen en une année entière.</> : <>Am Schweizer Himmel fliegen so viele Privatjets wie nirgendwo sonst in Europa. Gewisse Jets stossen in nur drei Flugstunden so viel CO<sub>2</sub> aus wie ein Durchschnittsschweizer in einem ganzen Jahr.</>
  )
  const [foundIsFree, setFoundIsFree] = useState<boolean>(false)
  const [foundHeading, setFoundHeading] = useState<string>(
    tenant.lang === 'fr'? 'Au détriment du climat' : 'Klimagerechtigkeit'
  )
  const [publishedDateFormatted, setPublishedDateFormatted] = useState<string>()
  const [publishedDate, setPublishedDate] = useState<string>(
    '2023-05-14T05:00:00.150240702Z'
  )

  const [isInApp, setIsInApp] = useState(false)
  const getArticleInfos = async () => {
    // https://feed-prod.unitycms.io/1/content/380782466042?reduced
    const articleID = getArticleId()
    if (articleID) {
      const url = `https://feed-prod.unitycms.io/${
        tenant.feedId
      }/content/${getArticleId()}?reduced=true`
      const res = fetch(url)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            return undefined
          }
        })
        .catch((error) => {
          console.error('Error:', error)
          return undefined
        })
      return res
    }
  }
  useEffect(() => {
    setIsInApp(new URL(window.location.href).searchParams.has('appwebview'))
    getArticleInfos().then((res) => {
      if (res) {
        const publishedDate = res.content?.meta?.published
        const formattedDate = new Date(publishedDate).toLocaleDateString(
          'de-CH',
          {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }
        )
        setPublishedDate(publishedDate)
        setPublishedDateFormatted(formattedDate)
        setFoundAuthors(res?.content?.meta?.authors)
        setFoundTitle(replaceAmpersand(res.content?.article?.title))
        setFoundLead(replaceAmpersand(res.content?.article?.lead))
        setFoundHeading(replaceAmpersand(res.content?.article?.titleHeader))
        setFoundIsFree(res.content?.paywall?.docType !== 'premium')
        return
      }
      if (publishedDate) {
        const formattedDate = new Date(publishedDate).toLocaleDateString(
          'de-CH',
          {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }
        )
        setPublishedDateFormatted(formattedDate)
      }
    })
  }, [])
  const isDarkMode = colorMode === 'dark'
  return (
    <>
      {/* <ChatBubbles/> */}
      <TextWidth>
        <Head isInApp={isInApp}>
          <Title tenantKey={tenant?.key}>
            <TitleHeader
              isFree={foundIsFree}
              tenantKey={tenant?.key}
              isDark={isDarkMode}
            >
              {foundHeading}
            </TitleHeader>
            <HiddenDash aria-hidden='true' role='presentation'>
              {' '}
              –{' '}
            </HiddenDash>
            <TitleText>{foundTitle}</TitleText>
          </Title>
          <Lead>{foundLead}</Lead>
          <Meta>
            {foundAuthors?.length && foundAuthors?.length > 0 && (
              <AuthorImages>
                {foundAuthors.map((author) => {
                  return (
                    author.userImage?.variants?.['400px']?.src && (
                      <img
                        key={author.publicUserId}
                        src={author.userImage?.variants?.['400px']?.src}
                        alt={author.name}
                      />
                    )
                  )
                })}
              </AuthorImages>
            )}
            <AuthorsAndDate>
              {foundAuthors?.length && foundAuthors?.length > 0 && (
                <Authors>
                  {foundAuthors?.map((author) => {
                    return (
                      <span key={author.publicUserId}>
                        <a
                          href={`https://www.${tenant?.key}.ch/author/${author.publicUserId}/${author.name}`}
                        >
                          {author.name}
                        </a>
                      </span>
                    )
                  })}
                </Authors>
              )}
              {publishedDate && publishedDateFormatted && (
                <time dateTime={publishedDate}>
                  {' '}
                  {(tenant.lang === 'fr' ? 'Publié: ' : 'Publiziert: ') +
                    publishedDateFormatted}
                </time>
              )}
            </AuthorsAndDate>
          </Meta>
          <GlobeImage
          isDarkmode={isDarkMode}
            src={require(isDarkMode
              ? '../GlobeView/GlobeImageDark-min.png'
              : '../GlobeView/GlobeImage-min.png')}
          />
        </Head>
      </TextWidth>
    </>
  )
}

const GlobeImage = styled.img<{isDarkmode: boolean}>`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  width: 100%;
  object-fit: contain;
  z-index: -1;
  /* max-width: 650px; */
  opacity: ${({isDarkmode})=> isDarkmode ? 1: 0.6};
`
const Wrapper = styled.div`
  display: flex;
  margin-top: 5em;
  justify-content: center;
  position: relative;
`
const Head = styled.div<{ isInApp: boolean }>`
  font-size: 3.3rem;
  color: var(--text-color);
  /* max-width: 668px; */
  margin: 0 auto;
  margin-top: 5em;
  @media (max-width: 768px) {
    margin-top: 2rem;
  }
  width: 100%;
  margin-bottom: 4rem;
  ${(props) => (props.isInApp ? `margin-top: 2rem;` : '')}
  text-size-adjust: 100%;
  overflow: hidden;
`
const TitleHeader = styled.span<{
  tenantKey?: string
  isFree?: boolean
  isDark?: boolean
}>`
  display: inline-block;
  font-size: 1.5rem;
  font-family: var(--font-plex);
  text-size-adjust: 100%;
  font-weight: 600;
  color: ${(props) => {
    if (props.isDark) {
      return 'var(--text-color)'
    }
    return props.tenantKey
      ? 'var(--tenant-' + props.tenantKey + ')'
      : 'var(--tenant-tagesanzeiger)'
  }};
  line-height: 2rem;
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  &::before {
    background-color: ${(props) =>
      props.tenantKey
        ? 'var(--tenant-' + props.tenantKey + ')'
        : 'var(--tenant-tagesanzeiger)'};
    display: ${(props) => (props.isFree ? 'none' : 'inline-block')};
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: white;
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-plex);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    content: 'Abo';
  }
  /* margin-right: 4ch; */
`
const HiddenDash = styled.span`
  display: none;
`
const TitleText = styled.span`
  font-family: var(--font-plex);

  @media (min-width: 541px) {
    font-size: 4.9rem;
    line-height: 5.2rem;
  }
  font-weight: 600;
  font-size: 3rem;
  line-height: 3rem;
  text-align: center;
`
const Title = styled.h2<{ tenantKey?: string }>`
  text-size-adjust: 100%;
  margin-top: 0.3rem;
  margin-bottom: 1.2rem;
  font-size: 10px;
  text-align: center;
`
const Lead = styled.h3`
  font-family: var(--font-plex);
  font-weight: 400;
  line-height: 2rem;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
  @media (min-width: 541px) {
    line-height: 2.9rem;
    font-size: 2rem;
    margin-bottom: 4rem;
  }
`
const Meta = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-plex);
  /* border-top: 1px solid var(--border-color); */
  padding-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  time {
    line-height: 1.8rem;
    margin: 0.2rem 0;
    color: var(--meta-data);
  }
`
const AuthorImages = styled.div`
  display: flex;
  flex-wrap: nowrap;
  /* margin: 0.2rem 0;
   */
  gap: 1rem;
  margin-right: 1rem;
  padding-bottom: 1rem;
  img {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
  }
`
const AuthorsAndDate = styled.div`
  display: flex;
  flex-direction: column;
`

const Authors = styled.div`
  color: var(--text-color);
  font-family: var(--font-plex);
  line-height: 1.8rem;

  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
export default TitleLead
